import { FC, useMemo } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { Tabs } from '@dynamika-shared/ui/Tabs/Tabs';
import { generateTabsItems } from '@utils/generateTabsItems';
import { clinicalTrialNotificationsTabsRoutes } from '@router/ClinicalTrial.routes';
import { useBreadcrumbs } from 'src/hooks/useBreadcrumbs';
import { useClinicalTrialSlice } from 'src/store-redux/clinicalTrial/clinicalTrial.slice';

export const ClinicalTrialNotifications: FC = () => {
  const { id } = useParams();
  const { pathname } = useLocation();

  const clinicalTrial = useClinicalTrialSlice(state => state.data);

  useBreadcrumbs(
    [
      ['Clinical Trials', 'clinicalTrial'],
      [clinicalTrial?.name, 'clinicalTrialGeneralInformation'],
      ['Notifications', 'clinicalTrialNotifications'],
    ],
    [id]
  );

  const currentPathname = useMemo(() => {
    const chunks = pathname.split('/');
    return chunks[chunks.length - 1];
  }, [pathname]);

  const items = useMemo(
    () =>
      generateTabsItems({
        routes: clinicalTrialNotificationsTabsRoutes,
        currentPathname,
        id,
        disableStyles: true,
      }),
    [id, currentPathname]
  );

  return (
    <div className='flex flex-col h-full'>
      <Tabs activeKey={currentPathname} items={items} mode={'button'} />
      <div className='grow'>
        <Outlet />
      </div>
    </div>
  );
};
